{
  "id": "skirmish_12",
  "name": "Skirmish-12",
  "mode": "HOTSEAT_2_4P",
  "ruleset": "OFFICIAL_SKIRMISH",
  "objective": "Eliminate every opposing team by removing its final figure.",
  "randomStart": true,
  "credits": {"EFA": 20, "REDCAT": 20, "GREEN": 20, "BLUE": 20},
  "terrain": [
    "VMVMVMVHVMVMVMVMVMVMV",
    "MMMMMMMMWMMMWHMMMMMMM",
    "MMMMMMGWWGGGWWGMMMMMM",
    "MMMMMMMWMMMMMWMMMMMMM",
    "MMMMMMWMGMMMMMWMMMMMM",
    "MMMMMWWMMMMMMMWWMGMMM",
    "GMHWMWMMHMMMGMMWMWMMH",
    "WWWMWMMMMMGMMMMMWMWWW",
    "MMGMMMGMMMMMMMHMMGGMM",
    "MMGHMMMMGMMGMMMMMMGMM",
    "MWGMMMHMMMMMMMGMMMGWM",
    "WMWWWWMMMMGMMMMWWWWMW",
    "HMMGMWMMGMMMHMMWMMHMG",
    "MMMMMMWMMMMMMMWMMMMMM",
    "MMMMMMWWGMMMGWWMMMMMM",
    "MMMMMMMWMGMGMWMMMMMMM",
    "MMMMMMHMWMHMWMGMMMMMM",
    "MMMMMMMGWMMMWHMMMMMMM"
  ],
  "bridges": [[6,5,false,1],[14,5,false,0],[6,13,false,0],[14,13,false,1]],
  "ore": [[9,1],[10,1],[11,1],[1,8],[0,9],[1,9],[19,8],[19,9],[20,9],[9,7],[10,7],[11,7],[8,8],[9,8],[10,8],[11,8],[12,8],[8,9],[9,9],[10,9],[11,9],[12,9],[8,10],[9,10],[10,10],[11,10],[12,10],[10,11],[9,16],[10,17],[11,16]],
  "pieces": [
    {"type":"MCV","owner":"EFA","col":1,"row":0},
    {"type":"MCV","owner":"BLUE","col":19,"row":0},
    {"type":"MCV","owner":"GREEN","col":1,"row":17},
    {"type":"MCV","owner":"REDCAT","col":19,"row":17}
  ]
}
